import { VideoData } from '../../../../interfaces'
import AnimationOverlay from '../AnimationOverlay'
import ShadowBackground from '../ShadowBackground'
import TokengateOverlay from '../TokengateOverlay'
import MobileControls from './MobileControls'
import MobileLoadingOverlay from './MobileLoadingOverlay'

//* ============================ Types =========================================

type MobileOverlayProps = {
  videoMetadata: VideoData
  scheduledTime: Date
}

//* ============================ React component ===============================

const MobileOverlay = ({ videoMetadata, scheduledTime }: MobileOverlayProps): JSX.Element => {
  return (
    <>
      <MobileLoadingOverlay />
      <ShadowBackground />
      <AnimationOverlay />
      <MobileControls video={videoMetadata} scheduledTime={scheduledTime} />
      <TokengateOverlay videoMetadata={videoMetadata} scheduledTime={scheduledTime} />
    </>
  )
}

export default MobileOverlay
